import SectionTitle from "./SectionTitle";

const FEED = [
  {
    time: "今日 09:24",
    tag: "现场视频",
    tone: "live" as const,
    title: "城市街口突发的一幕，多机位画面陆续归档",
    summary: "同一事件两处机位分别拍到，时间戳对得上，画面细节相互印证。",
    meta: "实拍 2 段 · 截图线索 4 条 · 讨论 63",
  },
  {
    time: "今晨 07:05",
    tag: "目击者说",
    tone: "witness" as const,
    title: "目击者先后发声，口径之间出现两处出入",
    summary: "关于先后顺序与在场人数说法不一，已把关键分歧列进线索对表。",
    meta: "目击 3 人 · 立场分歧 2 处 · 讨论 41",
  },
  {
    time: "昨日 22:40",
    tag: "图片流出",
    tone: "photo" as const,
    title: "一组流出图证补全了事发前的现场环境",
    summary: "多张环境实拍陆续流出，补充了此前画面缺失的方位与光照信息。",
    meta: "图证 7 张 · 环境核对完成 · 讨论 88",
  },
  {
    time: "昨日 18:12",
    tag: "截图线索",
    tone: "clue" as const,
    title: "聊天截图流传后，关键时间线被重新排序",
    summary: "一张时间戳截图改变了事件先后判断，原速递已附更正说明。",
    meta: "截图 2 张 · 已更正 · 讨论 120",
  },
  {
    time: "昨日 14:30",
    tag: "实拍",
    tone: "live" as const,
    title: "实拍直击画面流出，拍到此前缺失的侧向镜头",
    summary: "新一段实拍补上了正面机位看不到的角度，细节更接近全貌。",
    meta: "实拍 1 段 · 画面对照完成 · 讨论 56",
  },
];

const TAG_STYLE: Record<string, string> = {
  现场视频: "bg-primary-100 text-primary-700",
  实拍: "bg-primary-100 text-primary-700",
  图片流出: "bg-accent-100 text-accent-700",
  截图线索: "bg-secondary-100 text-secondary-700",
  目击者说: "bg-background-200 text-foreground-700",
};

const DOT_STYLE: Record<string, string> = {
  live: "bg-primary-500",
  witness: "bg-accent-500",
  photo: "bg-secondary-500",
  clue: "bg-foreground-950",
};

export default function Feed() {
  return (
    <section id="feed" className="scroll-mt-20 border-y border-foreground-200/70 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionTitle
          index="01"
          kicker="现场速递"
          title={<>一条时间线，把画面与说法串起来</>}
          lead="同一事件的现场视频、实拍与目击、截图按时间落位，谁先谁后、互相是否咬合，看这一栏就够了。每一条都标注了材料类型与讨论热度。"
        />

        <ol className="relative border-l border-foreground-200 pl-6 md:pl-10 space-y-10 md:space-y-12">
          {FEED.map((item) => (
            <li key={item.title} className="relative">
              <span
                className={`absolute -left-[31px] top-1.5 md:-left-[43px] flex h-3 w-3 items-center justify-center rounded-full ${DOT_STYLE[item.tone]} ring-4 ring-background-100`}
              />
              <div className="group max-w-3xl">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                  <span className="text-[12px] font-medium tracking-wide text-foreground-400">{item.time}</span>
                  <span className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-medium ${TAG_STYLE[item.tag]}`}>
                    {item.tag}
                  </span>
                </div>
                <a href="#discuss" className="mt-3 block font-serif text-lg font-bold leading-snug text-foreground-950 transition-colors hover:text-primary-600 md:text-[22px]">
                  {item.title}
                </a>
                <p className="mt-2 text-sm leading-6 text-foreground-500">{item.summary}</p>
                <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-[12px] text-foreground-400">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-folder-image-line text-[13px]" aria-hidden="true" />{item.meta}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-foreground-200/70 pt-6">
          <p className="text-[13px] text-foreground-500">速递按“出现时间”而非“发布先后”排列，便于还原先后关系。</p>
          <a href="#docs" className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap">
            进入影像图证 <i className="ri-arrow-right-line text-[15px]" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}